import { gql } from '@apollo/client';

export const GET_CONTINUE_WATCHING_LIST = gql`
  query getContinueWatchingList($offset: Int!, $first: Int!) {
    getContinueWatchingList(first: $first, offset: $offset) {
      nodes {
        cwCreatedAt
        cwId
        cwUpdatedAt
        cwUserId
        cwWatchedPosition
        cwJwMediaId
      }
      totalCount
    }
  }
`;

export const GET_CONTINUE_WATCHING_BY_JW_MEDIA_ID = gql`
  query getContinueWatchingByJWmediaid($jwMediaId: String!) {
    getContinueWatchingByJWmediaid(jwMediaId: $jwMediaId) {
      cwId
      cwJwMediaId
      cwUpdatedAt
      cwUserId
      cwWatchedPosition
      cwCreatedAt
    }
  }
`;

export interface ContinueWatchingNode {
  cwCreatedAt: string;
  cwId: string;
  cwUpdatedAt: string;
  cwUserId: string;
  cwWatchedPosition: number;
  cwJwMediaId: string;
}

export interface GetContinueWatchingListData {
  getContinueWatchingList: {
    nodes: ContinueWatchingNode[];
    totalCount: number;
  };
}

export interface GetContinueWatchingByJWMediaIdData {
  getContinueWatchingByJWmediaid: ContinueWatchingNode;
}
